import { useState } from 'react';
import { toast } from 'react-toastify';

export const useFormValidation = () => {
  const [errors, setErrors] = useState({
    titleErr: false,
    titleMsg: "",
    locationErr: false,
    locationMsg: "",
    unitTypeErr: false,
    unitTypeMsg: "",
    dateErr: false,
    dateMsg: "",
  });

  const clearError = (field) => {
    setErrors(prev => ({ 
      ...prev, 
      [`${field}Err`]: false, 
      [`${field}Msg`]: "" 
    }));
  };

  const validateForm = (formData) => {
    // Reset errors
    setErrors({
      titleErr: false,
      titleMsg: "",
      locationErr: false,
      locationMsg: "",
      unitTypeErr: false,
      unitTypeMsg: "",
      dateErr: false,
      dateMsg: "",
    });

    let hasErrors = false;

    if (!formData.title.trim()) {
      setErrors(prev => ({ ...prev, titleErr: true, titleMsg: "Please enter a project name" }));
      hasErrors = true;
    }

    if (!formData.unitType) {
      setErrors(prev => ({ ...prev, unitTypeErr: true, unitTypeMsg: "Please select a unit type" }));
      hasErrors = true;
    }

    if (!formData.projectDate) {
      setErrors(prev => ({ ...prev, dateErr: true, dateMsg: "Please select a project date" }));
      hasErrors = true;
    }

    if (formData.images.length === 0) {
      toast.error('Please upload at least one image');
      hasErrors = true;
    }

    return !hasErrors;
  };

  return {
    errors,
    clearError,
    validateForm
  };
};
